import { httpInstance as http } from "@/plugins/http";
import endpoints from "@/api/endpoints";

async function request(method, url, data) {
  const response = await http[method](url, data);
  if (!response || response.status > 299) {
    throw new Error(
      response?.data?.message || "The request failed. Please try again."
    );
  }
  return response.data;
}

export const listComponents = (params) =>
  request("get", endpoints.COMPONENTS, { params });
export const getComponentTypes = () =>
  request("get", endpoints.COMPONENT_TYPES);
export const getInventory = (id) =>
  request("get", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}`);
export const claimInventory = (id) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/claim`);
export const removeInventory = (id) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/remove`);
export const stockInventory = (id) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/stock`);
export const revokeInventory = (id) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/revoke`);
export const remoteInventory = (id, on) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/remote`, { on });
export const rebindInventory = (id, unclaimedInventoryId) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/rebind`, {
    unclaimed_inventory_id: unclaimedInventoryId,
  });
export const assignInventory = (cameraId, inventoryId) =>
  request("post", endpoints.CAMERA_DEVICE(cameraId), {
    pro_camera_inventory_id: inventoryId,
  });
// id is the numeric inventory ID; null clears the allocation or sets Natilon as owner.
export const allocateInventory = (id, companyId) =>
  request("post", endpoints.DEVICE_ALLOCATE(id), { company_id: companyId });
export const takeBackInventory = (id, reason, note) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/take-back`, { reason, note: note || null });
export const setInventoryOwner = (id, ownerCompanyId) =>
  request("post", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/ownership`, {
    owner_company_id: ownerCompanyId,
  });
export const findInventory = async (search) =>
  (
    await request("get", endpoints.PRO_CAMERA_INVENTORIES, {
      params: { search, page: 1, size: 1 },
    })
  ).data?.[0];
export const getComponent = (id, params) =>
  request("get", `${endpoints.COMPONENTS}/${id}`, { params });
export const saveComponent = ({ id, data, inventoryId }) =>
  request(
    id ? "patch" : "post",
    id
      ? `${endpoints.COMPONENTS}/${id}`
      : inventoryId
      ? `${endpoints.PRO_CAMERA_INVENTORIES}/${inventoryId}/components`
      : endpoints.COMPONENTS,
    data
  );
export const deleteComponent = (id) =>
  request("delete", `${endpoints.COMPONENTS}/${id}`);
export const getInventoryComponents = (id, params) =>
  request("get", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/components`, {
    params,
  });
export const installComponent = ({ inventoryId, componentId, note }) =>
  request(
    "post",
    `${endpoints.PRO_CAMERA_INVENTORIES}/${inventoryId}/installations`,
    { component_id: componentId, note }
  );
export const removeComponent = ({
  inventoryId,
  installationId,
  reason,
  note,
}) =>
  request(
    "post",
    `${endpoints.PRO_CAMERA_INVENTORIES}/${inventoryId}/installations/${installationId}/remove`,
    { reason, note }
  );
